module.exports = __webpack_public_path__ + "img/area_3.79d2331f.png";